import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './LandingPage.css';
import { Link, useNavigate } from 'react-router-dom';

// --- FEATURES DATA ---
const featuresList = [
  { 
    id: 1, icon: 'fa-video', title: 'Crystal Clear Video', 
    desc: 'Experience authentic, high-definition face-to-face encounters with low latency.',
    className: 'card-tall'
  },
  { 
    id: 2, icon: 'fa-shield-halved', title: 'AI-Powered Safety', 
    desc: 'Advanced AI technologies work in the background to keep chats clean and secure.',
    className: 'card-wide'
  },
  { 
    id: 3, icon: 'fa-bolt', title: 'Instant Connections', 
    desc: 'Our matching algorithm finds you someone interesting in milliseconds.' 
  },
  { 
    id: 4, icon: 'fa-masks-theater', title: 'Text or Video', 
    desc: 'Not camera ready? Switch seamlessly between anonymous text and video modes.' 
  },
  { 
    id: 5, icon: 'fa-user-group', title: 'Find Your Tribe', 
    desc: 'Use smart filters to narrow down searches by interests or location.' 
  },
];

// --- TESTIMONIALS DATA ---
const testimonials = [
  {
    name: 'Alex R.', label: 'Beta Tester',
    text: 'The UI is stunning. It feels like using a premium app from day one. Making friends here is incredibly easy and addictive.',
  },
  {
    name: 'Sarah K.', label: 'Verified User',
    text: 'I was skeptical of random chats, but the safety features here are next level. I finally feel comfortable meeting new people online.',
  },
  {
    name: 'David L.', label: 'Premium Member',
    text: 'The video quality is unmatched. No lag, just genuine conversations. This has completely replaced my other social apps.',
  },
];

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="harmoni-root">

      {/* --- NAVBAR --- */}
      <nav className="harmoni-nav">
        <div className="brand">
          <i className="fas fa-comments"></i> Harmoni
        </div>
        <div className="nav-actions">
          <Link to="/login" className="nav-link-login">Login</Link>
          <button className="nav-btn-register" onClick={() => navigate('/register')}>
            Get Started
          </button>
        </div>
      </nav>

      {/* --- HERO SECTION --- */}
      <header className="harmoni-hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Connect with the world,
            <span className="highlight">Randomly.</span>
          </h1>
          <p className="hero-desc">
            The modern alternative to classic chat platforms. Experience the thrill of meeting strangers in high-quality video and text chats, designed for the 2025 web.
          </p>
          <button className="hero-cta-btn" onClick={() => navigate('/register')}>
            Start Chatting Now
          </button>
        </div>

        <div className="hero-visual">
          <div className="graphic-wrapper">
            <div className="graphic-core"></div>
            <div className="graphic-ring ring-1"></div>
            <div className="graphic-ring ring-2"></div>
            <div className="graphic-ring ring-3"></div>
            <div className="graphic-orb-icon icon-top">
              <i className="fas fa-user"></i>
            </div>
            <div className="graphic-orb-icon icon-bottom">
              <i className="fas fa-video"></i>
            </div>
            <div className="graphic-orb-icon icon-right">
              <i className="fas fa-comment-dots"></i>
            </div>
          </div>
        </div>
      </header>

      {/* ------------------------------------------------------------------ */}
      {/* --- AI PARTNER SELECT SECTION (ADAM & EVE) — NEW SECTION ADDED ---- */}
      {/* ------------------------------------------------------------------ */}

    <section className="ai-selection-section">
        <h2 className="section-title">Talk to Your AI Partner</h2>

        <div className="ai-cards-container">
          {/* ---- ADAM ---- */}
          <div
            className="ai-card glass-card animate-card"
            onClick={() => navigate("/chat/adam")}
          >
            <img
              src="/images/adam.png"
              alt="Adam"
              className="ai-avatar floating-avatar"
            />
            <h3>Adam</h3>
            <p>Your AI Boyfriend 🤖</p>
          </div>

          {/* ---- EVE ---- */}
          <div
            className="ai-card glass-card animate-card"
           onClick={() => navigate("/chat/eve")}
          >
            <img
              src="/images/eve.png"
              alt="Eve"
              className="ai-avatar floating-avatar"
            />
            <h3>Eve</h3>
            <p>Your AI Girlfriend 🙎‍♀️</p>
          </div>
        </div>
      </section>


      {/* --- FEATURES BENTO GRID --- */}
      <section className="section-container">
        <div className="section-header">
          <h2 className="section-title">Engineered for Connection.</h2>
          <p className="section-desc">
            We've rethought random chat from the ground up, combining cutting-edge tech with premium design.
          </p>
        </div>

        <div className="bento-grid">
          {featuresList.map((feature) => (
            <div key={feature.id} className={`feature-card ${feature.className || ''}`}>
              <div className="feature-icon-box">
                <i className={`fas ${feature.icon}`}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* --- TESTIMONIALS --- */}
      <section className="section-container">
        <div className="section-header">
          <h2 className="section-title">Loved by Thousands.</h2>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((item, i) => (
            <div key={i} className="testimonial-card">
              <span className="user-badge">{item.label}</span>
              <p className="testimonial-text">"{item.text}"</p>
              <h4 style={{ marginTop: '20px', fontWeight: 800 }}>{item.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* --- DISCORD CTA BANNER --- */}
      <section className="discord-cta-section">
        <div className="discord-banner">
          <div className="discord-content">
            <h2>Join the Community</h2>
            <p>Get exclusive updates, participate in events, and meet the developers on our Discord server.</p>
          </div>
          <a href="https://discord.com/" target="_blank" rel="noreferrer" className="discord-btn">
            <i className="fab fa-discord"></i> Join Discord Server
          </a>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer className="premium-footer">
        <div className="footer-content">
          <div className="footer-brand-col">
            <div className="brand">
              <i className="fas fa-comments"></i> Harmoni
            </div>
            <p>The next generation of anonymous social discovery. Connect safely and seamlessly.</p>
          </div>

          <div className="footer-links-col">
            <div className="link-group">
              <h4>Platform</h4>
              <a href="#!">About</a>
              <a href="#!">Features</a>
              <a href="#!">Pricing</a>
            </div>
            <div className="link-group">
              <h4>Legal</h4>
              <a href="#!">Terms of Service</a>
              <a href="#!">Privacy Policy</a>
              <a href="#!">Safety Guidelines</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© 2025 Harmoni Chat Ltd. All rights reserved.</span>
          <div className="social-links">
            <a href="https://instagram.com" className="social-icon"><i className="fab fa-instagram"></i></a>
            <a href="https://twitter.com" className="social-icon"><i className="fab fa-x-twitter"></i></a>
            <a href="https://tiktok.com" className="social-icon"><i className="fab fa-tiktok"></i></a>
          </div>
        </div>
      </footer>

    </div>
  );
}
